import type { ReactNode } from "react";
import { showToast } from "@/components/extended/Toast";
import { ToastOptions } from "react-toastify";

export type ToastVariant = "success" | "error";

export const showToastDynamic = (
  message: ReactNode,
  type: ToastVariant,
  description?: ReactNode,
  options?: ToastOptions,
): void => {
  if (type === "success") {
    showToast.success(message, description, {
      position: "bottom-right",
      ...options,
    });
    return;
  }

  showToast.error(message, description, {
    position: "bottom-right",
    ...options,
  });
};
